import "./navbar.css"

export default function Navbar(props) {
    const items = [
        { label: "1º Ano", value: "1º ano" },
        { label: "2º Ano", value: "2º ano" },
        { label: "3º Ano", value: "3º ano" },
        { label: "Mestrado Matemática", value: "Mestrado em Matemática Aplicada e Computação" },
        { label: "Mestrado Ciência de Dados", value: "Mestrado em Engenharia e Ciência de Dados" },
        { label: "Doutoramento Matemática", value: "Programa Doutoral em Matemática" },
    ];

    return (
        <div className="segmented-control">
            {items.map((item) => (
                <button
                    key={item.value}
                    className={props.activeSection === item.value ? "active" : ""}
                    onClick={() => props.clickFunction(item.value)}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
}
